import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import { loadNewComps } from './features/actions/loadNewComps.ts';
import { setCompSequence } from './features/orderSlice.ts';
import { CompPropertyDataState, RootState } from './types.ts';

export const sortCompsMiddleware = createListenerMiddleware();

sortCompsMiddleware.startListening({
  matcher: isAnyOf(loadNewComps),
  effect: (_, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const { compSequence } = state.order;
    const { entities } = state.propertyData;

    // Sort comps by: 1) compType (aiv, arv, undefined), 2) status (SettledSale, Contract, Active, others)
    const sortedCompSequence = [...compSequence].sort((idA, idB) => {
      const compA = (entities[idA] as CompPropertyDataState)?.compData;
      const compB = (entities[idB] as CompPropertyDataState)?.compData;

      if (!compA || !compB) return 0;

      // First criteria: compType (aiv first, then arv, then undefined)
      const compTypeOrder = { aiv: 0, arv: 1, undefined: 2 };
      const compTypeA = compTypeOrder[compA.compType ?? 'undefined'];
      const compTypeB = compTypeOrder[compB.compType ?? 'undefined'];

      if (compTypeA !== compTypeB) {
        return compTypeA - compTypeB;
      }

      // Second criteria: transaction status (SettledSale, Contract, Active, others)
      const statusOrder: Record<string, number> = {
        SettledSale: 0,
        Contract: 1,
        Active: 2,
      };
      const statusA = compA.editableData.transaction.status;
      const statusB = compB.editableData.transaction.status;
      const orderA = statusA ? (statusOrder[statusA] ?? 3) : 3;
      const orderB = statusB ? (statusOrder[statusB] ?? 3) : 3;

      return orderA - orderB;
    });

    // Only dispatch if the sequence actually changed
    if (JSON.stringify(sortedCompSequence) !== JSON.stringify(compSequence)) {
      listenerApi.dispatch(setCompSequence(sortedCompSequence));
    }
  },
});
